
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinbhimashankar() {



    const cardData =
    {
        keyword: 'Cab Service in Bhimashankar',
        heading: 'Platinum24 Cabs: Cab Service in Bhimashankar',
        headingDescription: ' Platinum24 Cabs offers trusted Cab Service in Bhimashankar, ideal for devotees visiting the sacred Bhimashankar Jyotirlinga Temple and tourists exploring the lush Western Ghats. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable journey through the winding hill roads. With professional drivers experienced in ghat routes, punctual service, and transparent pricing, we make your travel smooth and stress-free. Whether it’s a pilgrimage trip, weekend getaway, or a family outing, Platinum24 Cabs guarantees reliable service, affordable fares, and a memorable travel experience in and around Bhimashankar.',

        top: 'Top Places to Visit in Bhimashankar with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "description": "The Bhimashankar Temple is one of the 12 Jyotirlingas of Lord Shiva, drawing lakhs of devotees every year. Built in Nagara style, its stone carvings and peaceful surroundings enhance its charm. Pilgrims believe visiting here brings liberation and blessings. Mahashivratri is celebrated with great devotion. Surrounded by dense forests, it blends spirituality with nature. Bhimashankar Temple is the heart of the region’s divinity."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Spread across 130 sq km, Bhimashankar Wildlife Sanctuary is a haven for nature lovers. It is home to the rare Giant Indian Squirrel, along with leopards, deer, and rich birdlife. Trekking trails take visitors through lush forests, waterfalls, and valleys. The sanctuary is also part of the Western Ghats’ biodiversity hotspot. Monsoon adds mist and greenery, making it more enchanting. It is Bhimashankar’s natural paradise."
  },
  {
    "title": "Hanuman Lake",
    "description": "Hanuman Lake, located near the temple, is a tranquil spot amidst greenery. It is believed to be associated with Lord Hanuman. Surrounded by forests, it attracts birds and offers peace to visitors. Pilgrims often rest here after temple darshan. Monsoon fills the lake with pristine waters. Hanuman Lake is Bhimashankar’s serene retreat."
  },
  {
    "title": "Gupt Bhimashankar",
    "description": "Gupt Bhimashankar is a hidden pilgrimage spot where a natural Shivlinga is formed in the river bed. It is about 3 km from the main temple. Pilgrims trek through scenic trails to reach this sacred site. The place is peaceful, away from crowds. Devotees consider it highly spiritual and mystical. Gupt Bhimashankar is the area’s divine hidden gem."
  },
  {
    "title": "Nagphani Point",
    "description": "Nagphani, also known as Duke’s Nose, is a viewpoint near Bhimashankar offering breathtaking panoramas. The cliff resembles a snake’s hood, hence the name. Trekkers love climbing here for sunrise and sunset views. Misty monsoon landscapes make it even more picturesque. Adventure seekers find it thrilling. Nagphani is Bhimashankar’s scenic vantage point."
  },
  {
    "title": "Ahupe Ghat",
    "description": "Ahupe Ghat is a scenic pass near Bhimashankar offering spectacular views of valleys and waterfalls. The trek here is popular among adventure enthusiasts. Dense forests and tribal villages add cultural flavor to the journey. During monsoon, the ghat becomes a green wonderland. Photographers capture stunning landscapes here. Ahupe Ghat is Bhimashankar’s offbeat natural escape."
  },
  {
    "title": "Sahyadri Trekking Trails",
    "description": "Bhimashankar is a popular trekking destination in the Sahyadri range. Trails pass through dense jungles, streams, and rocky patches. The Ganesh Ghat and Shidi Ghat routes are famous among trekkers. Monsoon treks are filled with mist, waterfalls, and wildflowers. The journey offers both adventure and spirituality. Bhimashankar treks are a blend of thrill and devotion."
  },
  {
    "title": "Bombay Point",
    "description": "Bombay Point near Bhimashankar is a popular spot offering panoramic views towards Mumbai. The viewpoint is surrounded by forests and valleys. It is peaceful and less crowded, ideal for picnics and photography. Misty mornings and clear skies make it picturesque. Travelers enjoy the serenity away from the temple bustle. Bombay Point is Bhimashankar’s quiet nature spot."
  },
  {
    "title": "Nagfani Trek",
    "description": "Nagfani Trek is one of the most thrilling treks around Bhimashankar. The trail leads to a high cliff with snake-hood shaped rock formations. Trekkers enjoy challenging climbs, fresh air, and Sahyadri views. Monsoon adds waterfalls and slippery paths for extra thrill. It is a favorite for adventure enthusiasts. Nagfani Trek is Bhimashankar’s adrenaline-filled experience."
  },
  {
    "title": "Tribal Villages near Bhimashankar",
    "description": "The forests around Bhimashankar are home to tribal communities like the Mahadev Koli. Villages showcase traditional lifestyles, handicrafts, and folk culture. Visitors experience rural Konkan hospitality and simplicity. Local guides narrate stories of faith and heritage. It offers a unique cultural immersion. Tribal villages are Bhimashankar’s living heritage."
  }
],


        "services": [
    {
      "name": "Bhimashankar Cab Service",
      "description": "Our Bhimashankar Cab Service is designed to offer travelers a reliable and convenient way to navigate the beautiful region of Bhimashankar. Whether you're a pilgrim visiting the famous Bhimashankar Temple or a nature lover exploring the wildlife sanctuary, our cabs provide a seamless transport experience. We offer a variety of vehicles — from small hatchbacks to large SUVs — all equipped with air conditioning, clean interiors, and safety features. With experienced local drivers, flexible booking options, and 24x7 support, your journey in and around Bhimashankar becomes worry-free and comfortable."
    },
    {
      "name": "Taxi Service Bhimashankar",
      "description": "Explore Bhimashankar with ease using our professional Taxi Service Bhimashankar. Ideal for tourists, families, and spiritual seekers, our service ensures that you get to your destination safely and on time. Our fleet includes well-maintained vehicles with courteous drivers who are familiar with all major routes and landmarks. Whether it’s a temple visit, a trek in the hills, or a return trip from Pune or Mumbai, we offer fixed-rate pricing, full sanitization, and round-the-clock availability for a smooth travel experience."
    },
    {
      "name": "Bhimashankar Local Taxi",
      "description": "Need to get around Bhimashankar? Our Bhimashankar Local Taxi service is perfect for short-distance travel within the area. Whether you're heading to the temple, local markets, hotels, or scenic spots nearby, our local taxis are fast, affordable, and reliable. Our drivers are locals who know the terrain and can help guide you through your visit. Book instantly and enjoy a comfortable ride that fits your schedule."
    },
    {
      "name": "Affordable Taxi Bhimashankar",
      "description": "Our Affordable Taxi Bhimashankar service is crafted for budget-conscious travelers who want dependable transportation without overspending. We offer competitive fixed pricing with no hidden charges, making it ideal for pilgrims, students, and families. Despite the low price, you'll enjoy clean, air-conditioned cars, trained drivers, and flexible rental plans. Book a cab for a few hours or an entire day and experience high-value service at low cost."
    },
    {
      "name": "Bhimashankar Taxi with Driver",
      "description": "Sit back and relax with our Bhimashankar Taxi with Driver service. All drivers are professionally trained, polite, and experienced in navigating both city roads and hilly terrains. Ideal for tourists, elders, and visitors unfamiliar with the region, this service ensures safe and stress-free travel. Whether it's for a day trip, temple tour, or a multi-stop journey, let our expert drivers handle the roads while you focus on your spiritual or leisure goals."
    },
    {
      "name": "Bhimashankar Airport Taxi",
      "description": "Need a pickup or drop-off at the airport? Our Bhimashankar Airport Taxi service offers seamless transfers to Pune and Mumbai airports. We track your flight in real-time to ensure timely service, even if there are delays. With spacious vehicles for luggage and comfortable seating, this service is perfect for solo travelers, groups, or families flying in or out. Book in advance and travel worry-free knowing your airport transfer is covered."
    },
    {
      "name": "Cab Rental Bhimashankar",
      "description": "Looking for a vehicle for a few hours or the whole day? Our Cab Rental Bhimashankar service offers flexible rental options tailored to your needs. Choose from self-drive or chauffeur-driven cabs available in various models — economy, premium, or SUVs. Perfect for weddings, sightseeing, or business purposes, our cabs are maintained to the highest standards. All bookings come with clear billing, fuel options, and the convenience of doorstep pickup/drop-off."
    },
    {
      "name": "Bhimashankar Outstation Taxi",
      "description": "Planning to visit nearby destinations from Bhimashankar? Our Bhimashankar Outstation Taxi service covers major cities like Pune, Mumbai, Nashik, and more. Ideal for round-trips or one-way travel, this service includes fuel, tolls, and experienced drivers who ensure your journey is safe and timely. Travel in comfort with clean, GPS-enabled vehicles and take advantage of our 24x7 support for any help during the trip."
    },
    {
      "name": "Bhimashankar Corporate Taxi",
      "description": "Professional, prompt, and efficient — our Bhimashankar Corporate Taxi service is ideal for companies, institutions, and professionals visiting the region for events or retreats. We offer executive cars with premium interiors, polite chauffeurs, and customizable plans for staff transportation, guest pickups, or business tours. GST billing, monthly invoicing, and fleet customization options are available for corporate accounts."
    },
    {
      "name": "Bhimashankar Taxi Deals",
      "description": "Save more with our Bhimashankar Taxi Deals. From seasonal offers to group discounts, we provide special rates for early bookings, round-trips, and religious group travel. Our promotional pricing ensures you get maximum value without compromising on quality. Check our website or app for ongoing offers and make the most of your trip to Bhimashankar without stretching your budget."
    },
    {
      "name": "Bhimashankar Family Taxi Service",
      "description": "Travel with your loved ones safely using our Bhimashankar Family Taxi Service. Our vehicles are spacious, comfortable, and come equipped with family-friendly features like child locks, booster seats (on request), and ample luggage space. Ideal for pilgrimages, picnics, and sightseeing, this service prioritizes comfort and safety for all ages. Our drivers are courteous and patient, ensuring a peaceful travel experience for families of all sizes."
    },
    {
      "name": "Taxi Booking Online Bhimashankar",
      "description": "Book your ride in seconds with Taxi Booking Online Bhimashankar. Our website and mobile booking system let you choose your vehicle, set pickup and drop times, and pay securely online. With instant confirmations, live tracking, and customer support, online booking has never been easier. Whether you're planning in advance or need a last-minute ride, our platform ensures fast and reliable taxi reservations anytime, anywhere."
    },
    {
      "name": "Bhimashankar Taxi Service 24x7",
      "description": "No matter the time, our Bhimashankar Taxi Service 24x7 is always available. We operate round-the-clock to meet your transportation needs, whether it’s an early temple visit, a late-night return from the airport, or an emergency trip. Our fleet and support team are on standby 24/7 to ensure safe and prompt service whenever you need it. Trust us to be your dependable travel partner in Bhimashankar, day or night."
    }
  ],
  "tableData": [
    ["Bhimashankar Cab Service", "Taxi Service Bhimashankar"],
    ["Bhimashankar Local Taxi", "Affordable Taxi Bhimashankar"],
    ["Bhimashankar Taxi with Driver", "Bhimashankar Airport Taxi"],
    ["Cab Rental Bhimashankar", "Bhimashankar Outstation Taxi"],
    ["Bhimashankar Corporate Taxi", "Bhimashankar Taxi Deals"],
    ["Bhimashankar Family Taxi Service", "Taxi Booking Online Bhimashankar"],
    ["Bhimashankar Taxi Service 24x7", "—"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Cab Service in Bhimashankar",
    "WhyChoosedescription": "Platinum24 Cabs offers dependable and affordable cab services in Bhimashankar for local sightseeing and pilgrimage travel."
  },
  {
    "WhyChooseheading": "Comfortable Vehicle Options for Every Journey",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers to suit your travel group and comfort level."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Safe Travel",
    "WhyChoosedescription": "Our cabs are thoroughly cleaned and sanitized before every trip to ensure your health and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Bhimashankar Routes",
    "WhyChoosedescription": "Our drivers are familiar with the Bhimashankar region and ensure a smooth, safe, and timely journey."
  },
  {
    "WhyChooseheading": "All-Inclusive and Transparent Pricing",
    "WhyChoosedescription": "No hidden charges—our fares include fuel, tolls, and driver allowance for complete peace of mind."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Booking and Assistance",
    "WhyChoosedescription": "Our support team is available round the clock to help you with your Bhimashankar cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Pilgrims and Tourists",
    "WhyChoosedescription": "Choose from hourly, full-day, or custom packages based on your visit to Bhimashankar Temple and nearby spots."
  },
  {
    "WhyChooseheading": "Quick Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Bhimashankar cab quickly and securely through our website or app with instant updates."
  }
]

















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Bhimashankar?',
        answer: 'Yes, Platinum24 Cabs provides dependable cab services to and from Bhimashankar, including temple visits and sightseeing.',
    },
    {
        question: 'How can I book a cab for Bhimashankar with Platinum24 Cabs?',
        answer: 'You can book your cab easily through our website, mobile app, or by calling our 24x7 customer care team.',
    },
    {
        question: 'What types of vehicles are available for Bhimashankar cab service?',
        answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, and tempo travellers for group travel to Bhimashankar.',
    },
    {
        question: 'Is round-trip cab service available for Bhimashankar?',
        answer: 'Yes, we provide round-trip as well as one-way cab options for Bhimashankar as per your convenience.',
    },
    {
        question: 'Are the drivers familiar with the Bhimashankar temple route?',
        answer: 'Absolutely, our drivers are experienced and well-acquainted with the routes to Bhimashankar and nearby attractions.',
    },
    {
        question: 'Can I hire a cab for a same-day Bhimashankar trip?',
        answer: 'Yes, Platinum24 Cabs offers same-day return trips to Bhimashankar with flexible pickup and drop timings.',
    },
    {
        question: 'Are the cabs sanitized and safe for travel to Bhimashankar?',
        answer: 'Yes, all our vehicles are regularly sanitized and drivers follow strict hygiene and safety protocols.',
    },
    {
        question: 'Is cab service to Bhimashankar available 24x7?',
        answer: 'Yes, you can book a cab to Bhimashankar anytime, as our services operate 24x7.',
    },
    {
        question: 'What are the payment options for Bhimashankar cab service?',
        answer: 'We accept cash, UPI, digital wallets, and card payments for smooth and secure transactions.',
    },
    {
        question: 'Can I choose my pickup point for a cab to Bhimashankar?',
        answer: 'Yes, you can specify your preferred pickup location from anywhere in Pune or nearby areas for your Bhimashankar trip.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ganesh Patil',
        feedback: 'Had a peaceful trip to Bhimashankar with Platinum24 Cabs. The driver was polite and the cab was clean.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Rina Khedekar',
        feedback: 'Excellent service for Bhimashankar temple visit. On-time pickup and safe driving throughout the journey.',
        rating: 5,
    },
];









































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const bhimashankarCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable cab service in Bhimashankar offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver.",
  "areaServed": {
    "@type": "Place",
    "name": "Bhimashankar, Pune"
  },
  "serviceType": [
    "Bhimashankar Cab Service",
    "Taxi Service Bhimashankar",
    "Bhimashankar Local Taxi",
    "Affordable Taxi Bhimashankar",
    "Bhimashankar Taxi with Driver",
    "Bhimashankar Airport Taxi",
    "Cab Rental Bhimashankar",
    "Bhimashankar Outstation Taxi",
    "Bhimashankar Corporate Taxi",
    "Bhimashankar Taxi Deals",
    "Bhimashankar Family Taxi Service",
    "Taxi Booking Online Bhimashankar",
    "Bhimashankar Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};






    return (
        <div>

<Helmet>
  <title>Cab Service in Bhimashankar | Affordable Taxi Service Bhimashankar Pune</title>
  <meta
    name="description"
    content="Reliable and affordable cab service in Bhimashankar offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver."
  />
  <meta
    name="keywords"
    content="Bhimashankar Cab Service, Taxi Service Bhimashankar, Bhimashankar Local Taxi, Affordable Taxi Bhimashankar, Bhimashankar Taxi with Driver, Bhimashankar Airport Taxi, Cab Rental Bhimashankar, Bhimashankar Outstation Taxi, Bhimashankar Corporate Taxi, Bhimashankar Taxi Deals, Bhimashankar Family Taxi Service, Taxi Booking Online Bhimashankar, Bhimashankar Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(bhimashankarCabServiceSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/89.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinbhimashankar;